module.exports = __webpack_public_path__ + "img/home_03.2b2e9604.png";